import {
  //
  ADD_LOCATION_BLOGS,
  ADD_LOCATION_BLOGS_FAILURE,
  ADD_LOCATION_BLOGS_SUCCESS,
  //
  DELETE_LOCATION_BLOGS,
  DELETE_LOCATION_BLOGS_FAILURE,
  DELETE_LOCATION_BLOGS_SUCCESS,
  //
  EDIT_LOCATION_BLOGS,
  EDIT_LOCATION_BLOGS_FAILURE,
  EDIT_LOCATION_BLOGS_SUCCESS,
  //
  FETCH_LOCATION_BLOGS,
  FETCH_LOCATION_BLOGS_FAILURE,
  FETCH_LOCATION_BLOGS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  OPEN_BLOG_ADD_MODAL,
  CLOSE_BLOG_ADD_MODAL,
  //
  OPEN_BLOG_EDIT_MODAL,
  CLOSE_BLOG_EDIT_MODAL,
  SET_BLOG_SUCCESS,
  SET_BLOG_FAILURE,
} from "./constants";

// List
export const fetchLocationBlogs = (payload) => ({
  type: FETCH_LOCATION_BLOGS,
  payload,
});
export const fetchLocationBlogsSuccess = (payload) => ({
  type: FETCH_LOCATION_BLOGS_SUCCESS,
  payload,
});
export const fetchLocationBlogsFailure = (payload) => ({
  type: FETCH_LOCATION_BLOGS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addLocationBlogs = (payload) => ({
  type: ADD_LOCATION_BLOGS,
  payload,
});
export const addLocationBlogsSuccess = (payload) => ({
  type: ADD_LOCATION_BLOGS_SUCCESS,
  payload,
});
export const addLocationBlogsFailure = (payload) => ({
  type: ADD_LOCATION_BLOGS_FAILURE,
  payload,
});
// EDIT
export const editLocationBlogs = (payload) => ({
  type: EDIT_LOCATION_BLOGS,
  payload,
});
export const editLocationBlogsSuccess = (payload) => ({
  type: EDIT_LOCATION_BLOGS_SUCCESS,
  payload,
});
export const editLocationBlogsFailure = (payload) => ({
  type: EDIT_LOCATION_BLOGS_FAILURE,
  payload,
});
// DELETE
export const deleteLocationBlogs = (payload) => ({
  type: DELETE_LOCATION_BLOGS,
  payload,
});
export const deleteLocationBlogsSuccess = (payload) => ({
  type: DELETE_LOCATION_BLOGS_SUCCESS,
  payload,
});
export const deleteLocationBlogsFailure = (payload) => ({
  type: DELETE_LOCATION_BLOGS_FAILURE,
  payload,
});
//
export const openBlogAddModal = (payload) => ({
  type: OPEN_BLOG_ADD_MODAL,
  payload,
});
export const closeBlogAddModal = (payload) => ({
  type: CLOSE_BLOG_ADD_MODAL,
  payload,
});
export const openBlogEditModal = (payload) => ({
  type: OPEN_BLOG_EDIT_MODAL,
  payload,
});
export const closeBlogEditModal = (payload) => ({
  type: CLOSE_BLOG_EDIT_MODAL,
  payload,
});
export const setBlogSuccess = (payload) => ({
  type: SET_BLOG_SUCCESS,
  payload,
});
export const setBlogFailure = (payload) => ({
  type: SET_BLOG_FAILURE,
  payload,
});
